export class customEventsNames{
    constructor() {
        this.openModal = 'openModal';
        this.closeModal = 'closeModal';
        this.playVideoInModal = 'playVideoInModal';
        this.playYoutubeVideoInModal = 'playYoutubeVideoInModal';
        this.videoPlayingInModal = 'videoStartedPlayingInModal';
    }
};
export default new customEventsNames();